import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=a834d3de&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=a834d3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a834d3de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a834d3de')) {
      api.createRecord('a834d3de', component.options)
    } else {
      api.reload('a834d3de', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=a834d3de&scoped=true&", function () {
      api.rerender('a834d3de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bhCef0gGyCIB/JS/comp/DocBox.vue"
export default component.exports